import {EntityArray} from '../core/entityArray';

/**
 * Chat Permission collection
 * */
export class ChatPermissions extends EntityArray<string> {

  /**
   * @return if user can use chat service
   * */
  public canUseChat() {
    return this.includes('appChatAccessToChat');
  }

  /**
   * @return if user can create Groups
   * */
  public canCreateGroups() {
    return this.includes('appChatCreateGroup');
  }

}
